import React from 'react';

import { link } from '@aline/routes';
import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import { Link } from 'react-router-dom';
import type { ReportGridRow } from 'src/components';
import { StorableIcon, useCellStyles } from 'src/components';
import { openLinkFromAnchorClick } from 'src/helpers';
import { alineLinkButtonStylesWithUnderlineNotBold, createClampStyles } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useNameStyles = makeStyles()(_theme => ({
  nameLink: {
    minWidth: 0,
    textDecoration: 'none',
  },
  nameText: {
    ...createClampStyles(2),
    ...alineLinkButtonStylesWithUnderlineNotBold,
  },
}));

export function DocumentNameCell({ row, value }: GridCellParams<ReportGridRow>): JSX.Element {
  const { classes } = useNameStyles();
  const cellClasses = useCellStyles();
  const documentHref = link.DocumentDetail({ documentId: row.id });
  const title = typeof value === 'string' && value ? value : 'Untitled Document';

  return (
    <div className={cellClasses.cell}>
      <StorableIcon storable={row} />
      <Link
        className={classes.nameLink}
        to={documentHref}
        onClick={e => openLinkFromAnchorClick(e, documentHref, { title })}
      >
        <Typography className={classes.nameText} variant="subtitle2">
          {title}
        </Typography>
      </Link>
    </div>
  );
}
